import React, { useEffect, useState } from 'react';
import { Modal, Box, H3, T, Input, Button, ModalContent } from '@veracity/vui';
import InputField from './InputField';

const CheckModal = ({ 
    isOpen, 
    onClose, 
    action, 
    checkLabel, 
    checkId, 
    onConfirm,
    inputType = 'Text',
    inputOptions = [],
    inputLabel = 'Comment',
    isRequired = false
}) => {
    const isApprove = action === 'approve';
    const [inputValue, setInputValue] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [additionalComment, setAdditionalComment] = useState('');

    useEffect(() => {
        if (isOpen) {
            if (inputType === 'Checkbox') {
                if (inputOptions && inputOptions.length > 0) {
                    setInputValue([]);
                } else {
                    setInputValue(false);
                }
            } else {
                setInputValue('');
            }
            setAdditionalComment('');
            setIsUploading(false);
        }
    }, [isOpen, action, checkId, inputType, inputOptions]);

    const handleInputChange = (value) => {
        setInputValue(value);

        
    }

    const handleConfirm = async () => {
        if (isRequired) {
            if (inputType === 'Checkbox') {
                if (inputOptions && inputOptions.length > 0) {
                    if (!Array.isArray(inputValue) || inputValue.length === 0) {
                        return;
                    }
                } else {
                    if (inputValue === false) {
                        return;
                    }
                }
            } else if (!inputValue) {
                return;
            }
        }

        if (inputType === 'Image' && inputValue) {
            try {
                setIsUploading(true);
                console.log('Uploading image...');

                const result = await uploadImageBlob(inputValue);

                onConfirm({
                    checkId,
                    action,
                    value: result.Id,
                    additionalComment: additionalComment
                });
                console.log('Image uploaded successfully:', result);
                onClose();
                setIsUploading(false);
            }
            catch (error) {
                console.error('Error uploading image:', error);
                setIsUploading(false);
                return;
            }
        } else {
            onConfirm({
                checkId,
                action,
                value: inputValue,
                additionalComment: additionalComment
            });
            onClose();    
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} disableBackdropClose>
            <ModalContent>
                <Box 
                    flexDirection="column" 
                    bg="white"
                    boxShadow="modal"
                    left="50%"
                    top="50%"
                    transform="translate(-50%, -50%)"
                    position="absolute"
                    p={4}
                    minW="40%"
                    borderRadius={2}
                    outline="none"
                    gap={2}
                >
                    <H3 fontWeight="demi" alignSelf="center" mb={2}>{isApprove ? "Approve Check" : "Discard Check"}</H3>
                    <Box flexDirection="column" gap={1} alignItems="flex-start">
                        <T fontWeight="demi">{checkLabel}</T>
                        <Box flexDirection="column" w="100%">
                          
                            <InputField
                                type={inputType}
                                label={inputLabel}
                                value={inputValue}
                                onChange={setInputValue}
                                options={inputOptions}
                                required={isRequired} 
                            />

                            <Box flexDirection="column" w="100%" mt={2}>
                                <T mb={1}>Additional Comment</T>
                                <Input
                                    placeholder="Enter additional comment"
                                    value={additionalComment}
                                    onChange={(e) => setAdditionalComment(e.target.value)}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <Box mt={2}>
                        <Button variant="primaryDark" onClick={handleConfirm}>
                            Confirm
                        </Button>
                        <Button variant="secondaryDark" ml={2} onClick={() => {onClose(); console.log("closed");}}>
                            Cancel
                        </Button>
                    </Box>

                </Box>
            </ModalContent>
        </ Modal>
    )
}

export default CheckModal;